import { FormControl } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormikNumericField, HelpTooltip } from 'components';
import { useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';

export const MaxParallelCustomerOrdersField: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });
  const { isAdminOrTechOperator } = useUser();

  return (
    <FormControl sx={{ flexDirection: 'row', alignItems: 'center' }}>
      <FormikNumericField
        name="maxParallelCustomerOrders"
        label={t('fields.max_parallel_customer_orders')}
        fullWidth
        disabled={!isAdminOrTechOperator}
        allowNegative={false}
        decimalScale={0}
        defaultValue={null}
      />
      <HelpTooltip title={t('fields.max_parallel_customer_orders_helper')} />
    </FormControl>
  );
};
